import { getLegacyOfferGroup } from '../../../../../utils/productIdentityUtils';
import type { MedicationClaims } from '../types';

export type CompoundedGlp1 = 'SEMAGLUTIDE' | 'TIRZEPATIDE';

// branded and microdosing products sit in other offer groups, so they are not compounded GLP-1s
const COMPOUNDED_GLP1_BY_OFFER_GROUP_ID: Partial<Record<string, CompoundedGlp1>> = {
	SE: 'SEMAGLUTIDE',
	TI: 'TIRZEPATIDE'
};

// accepts a sku or a url token ("se", "ti")
export const getCompoundedGlp1 = (skuOrToken: string | null): CompoundedGlp1 | null => (
	COMPOUNDED_GLP1_BY_OFFER_GROUP_ID[getLegacyOfferGroup(skuOrToken ?? '')?.id ?? ''] ?? null
);

export const getMedicationClaims = (
	sku: string,
	claimsByMedication: Record<CompoundedGlp1, MedicationClaims>
): MedicationClaims | null => {
	const medication = getCompoundedGlp1(sku);

	return medication !== null ? claimsByMedication[medication] : null;
};
